export const COLORS = {
    main_bg_color_dark: 'rgb(21, 32, 43)',
    main_bg_color_light: 'white',
    main_font_color_dark: 'white',
    main_font_color_light: 'black',
    main_border_color: 'rgb(230, 236, 240)',
    main_searchbar_color_dark: 'rgb(37, 51, 65)',
    main_searchbar_color_light: 'rgb(230, 236, 240)',
    main_table_row_color_dark: '#30475e',
    main_table_row_color_light: 'rgb(230, 236, 240)',
    selected_border_color: 'rgb(29, 161, 242)',
}

export const ITEM_TYPES = {
    OPTION: 'option'
}

export const SKIP_TITLES = ['country', 'countryInfo']